export default __webpack_public_path__ + "static/cultural-080db8b0cf52bba8d888f7475e30a134.png";